// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__24mPN","descriptionCol":"Card_descriptionCol__CU6oo","imgCol":"Card_imgCol__2O9Xb","img":"Card_img__1xz0n"};